define('AwaLabs.RestrictedItems', [
    'RestrictedItems.View'
], function RestrictedItems(
    RestrictedItemsView
) {
    'use strict';


    return {
        mountToApp: function mountToApp(container) {
            var pdp = container.getComponent('PDP');
            if (pdp) {
                pdp.addChildViews(pdp.PDP_FULL_VIEW, {
                    'SpiritsMessage.View': {
                        'SpiritsMessage.View': {
                            childViewIndex: 1,
                            childViewConstructor: function childViewConstructor() {
                                return new RestrictedItemsView({ application: container });
                            }
                        }
                    }
                });
            }
        }
    };
});
